import { Injectable, ApplicationRef, createComponent, EnvironmentInjector } from '@angular/core';
import { ToastComponent } from './toast.component.js';

interface ToastData {
    message: string;
    type: string;
    title: string;
    icon: string;
    duration: number;
}

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private queue: ToastData[] = [];
    private isShowing = false;

    constructor(
        private appRef: ApplicationRef,
        private environmentInjector: EnvironmentInjector
    ) {}


    show(message: string, type: string = 'info', title: string = '', duration: number = 3000): void {
        type = type.toLowerCase();

        let icon = '';
        let toastTitle = title;

        if (type === 'info') {
            toastTitle = "Info";
            icon = 'fa-solid fa-circle-info';
        }
        else if (type === 'success') {
            toastTitle = "Success";
            icon = 'fa-solid fa-circle-check';
        }
        else if (type === 'error') {
            // Increase duration to allow screenshots
            duration = 6000;

            toastTitle = "Error";
            icon = 'fa-solid fa-circle-xmark';
        }
        else if (type === 'warning') {
            // Increase duration to allow screenshots
            duration = 6000;

            toastTitle = "Warning";
            icon = 'fa-solid fa-circle-exclamation';
        }

        this.queue.push({ message, type, title: toastTitle, icon, duration });
        this.displayNext();
    }

    private displayNext() {
        if (this.isShowing || this.queue.length === 0) return;

        this.isShowing = true;
        const { message, type, title, icon, duration } = this.queue.shift()!;

        const component = createComponent(ToastComponent, {
            environmentInjector: this.environmentInjector
        });

        component.instance.message = message;
        component.instance.type = type;
        component.instance.title = title;
        component.instance.icon = icon;

        this.appRef.attachView(component.hostView);
        const element = (component.hostView as any).rootNodes[0] as HTMLElement;

        document.body.appendChild(element);

        setTimeout(() => {
            this.appRef.detachView(component.hostView);
            component.destroy();
            this.isShowing = false;
            this.displayNext();
        }, duration);
    }
}
